import { StandardEvents } from '@shopify/events';

class JbgRewardsPoints extends HTMLElement {
  #section;
  #request = 0;

  connectedCallback() {
    this.addEventListener('click', this.#openRewards);
    this.#section = this.closest('.shopify-section, dialog');
    this.#section?.addEventListener(StandardEvents.productSelect, this.#update);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#openRewards);
    this.#section?.removeEventListener(StandardEvents.productSelect, this.#update);
    this.#request++;
  }

  #openRewards = async (event) => {
    try {
      const link = event.target instanceof Element ? event.target.closest('.jbg-points__link') : null;
      if (!link || !this.contains(link) || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (typeof window.SmileUI?.openPanel === 'function') {
        event.preventDefault();
        try {
          await window.SmileUI.openPanel();
        } catch {
          // Keep shoppers on the product page if the loaded Smile panel fails to open.
        }
      } else if (link.getAttribute('href') === '#') {
        event.preventDefault();
      }
    } catch {
      // Leave the native fallback link usable if Smile is unavailable.
    }
  };

  #update = async (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    const request = ++this.#request;
    try {
      const { detail } = await event.promise;
      if (!this.isConnected || request !== this.#request || !detail?.html) return;
      if (!detail.newProduct && detail.productId && String(detail.productId) !== this.dataset.productId) return;
      const next = detail.html.querySelector(
        `jbg-rewards-points[data-block-id="${CSS.escape(this.dataset.blockId)}"]`
      );
      if (!next) return;
      const content = next.querySelector('.jbg-points__content');
      const message = next.querySelector('.jbg-points__message');
      const priceCents = Number(content?.dataset.priceCents);
      const rate = Number(content?.dataset.pointsRate);
      if (message && Number.isFinite(priceCents) && Number.isFinite(rate) && rate > 0) {
        const points = Math.round(priceCents * rate / 100);
        message.textContent = message.dataset.pointsTemplate.replace('__JBG_POINTS__', String(points));
      }
      this.dataset.productId = next.dataset.productId;
      this.replaceChildren(...Array.from(next.childNodes, (node) => node.cloneNode(true)));
    } catch (error) {
      if (error?.name !== 'AbortError') console.warn('[jbg-rewards-points]', error);
    }
  };
}

if (!customElements.get('jbg-rewards-points')) {
  customElements.define('jbg-rewards-points', JbgRewardsPoints);
}
